window.theme = window.theme || {}, window.theme.sections = window.theme.sections || {}, window.theme.sections.blogFeatures = window.theme.sections.blogFeatures || [], document.querySelectorAll(".blog-feature-navigation__link").forEach((e => {
  let t = e.dataset.handle;
  e.addEventListener("click", (e => {
    e.preventDefault(), document.querySelectorAll(".blog-feature-section").forEach((e => {
      e.dataset.handle === t ? e.classList.add("active") : e.classList.remove("active")
    })), document.querySelectorAll(".blog-feature-navigation__link").forEach((e => {
      e.dataset.handle === t ? e.classList.add("active") : e.classList.remove("active")
    }))
  }))
}));